import { DISPATCH_TARGET } from "../../../../../shared/constants/dispatchTarget";
import DispatchRegister from "../../../../../components/units/Management/Dispatch/Register";

export default function DispatchEpTpRegisterPage() {
  return <DispatchRegister target={DISPATCH_TARGET.epTp} />;
}
